<template>
  <div
    :class="[rootClass, 'field-select-root']"
    @mouseenter="onFieldEnter"
    @mouseleave="fieldTooltip = false"
  >
    <q-select
      outlined
      dense
      v-model="selectedValue"
      map-options
      emit-value
      hide-dropdown-icon
      :required="isRequired"
      :options="filteredOptions"
      option-value="id"
      option-label="label"
      :for="label"
      :placeholder="placeholder"
      :readonly="disabled"
      bg-color="white"
      :use-input="useFilter"
      @filter="filterOptions"
      :options-dense="true"
      class="col-auto myFieldSelect"
      popup-content-class="field-select-popup"
      @popup-show="measureOptions"
      @virtual-scroll="measureOptions"
    >
      <template #append>
        <div class="row items-center justify-center">
          <ArrowDownIcon class="col" />
        </div>
      </template>

      <template #selected>
        <span class="ellipsis field-select-value">{{ showLabel }}</span>
      </template>

      <template #option="scope">
        <q-item
          v-bind="scope.itemProps"
          v-on="scope.itemEvents"
        >
          <q-item-section>
            <q-item-label
              class="ellipsis"
              :data-option-index="scope.index"
            >
              {{ scope.opt.label }}
            </q-item-label>
          </q-item-section>
          <q-tooltip
            v-if="truncatedOptions.includes(scope.index)"
            :delay="300"
          >
            {{ scope.opt.label }}
          </q-tooltip>
        </q-item>
      </template>

      <q-tooltip
        no-parent-event
        :value="fieldTooltip"
        :delay="300"
      >
        {{ showLabel }}
      </q-tooltip>
    </q-select>
  </div>
</template>

<script>
import ArrowDownIcon from '@/assets/icons/arrowDown.svg'
import truncateTooltip from '@/mixins/truncateTooltip'

export default {
  components: {
    ArrowDownIcon
  },

  mixins: [truncateTooltip],

  props: {
    list: {},
    value: {},
    label: {},
    configs: {},
    disabled: {},
    placeholder: {},
    useFilter: {
      default: false
    },

    clearable: {
      default: false
    },

    rootClass: {
      default: 'column'
    }
  },

  data () {
    return {
      selectedValue: this.value,
      filteredOptions: this.list
    }
  },

  computed: {
    isRequired () {
      return !this.configs ? false : this.configs.fieldRequired === 'yes'
    },

    showLabel () {
      if (isUnfilled(this.selectedValue)) return this.placeholder
      const options = Array.isArray(this.list) ? this.list : []
      const item = options.find((item) => item.id === this.selectedValue)
      return item?.label ?? item?.name ?? ''
    }
  },

  methods: {
    filterOptions (val, update) {
      const isEmpty = val === ''
      const needle = val.toLowerCase()

      update(() => {
        this.filteredOptions = isEmpty
          ? this.list
          : this.list.filter(option => option.label.toLowerCase().includes(needle))
        this.measureOptions()
      })
    }
  },

  watch: {
    selectedValue (selectedValue) {
      if (selectedValue === this.value) return
      this.$emit('input', selectedValue)
    },

    value (value) {
      if (value === this.selectedValue) return
      this.selectedValue = value
    }
  }
}

const isUnfilled = (val) => [null, undefined].includes(val)
</script>

<style lang="sass">
// Quasar's .column wraps, so without containment a long label widens the whole column
.field-select-root
  contain: inline-size
  min-width: 0
  max-width: 100%

.field-select-popup
  max-width: min(480px, calc(100vw - 32px))

.myFieldSelect
  max-width: 100%
  .q-field__control-container
    min-width: 0

  .q-field__control
    min-height: 32px !important
    color: #4c8ec5 !important
    .q-field__control-container
      font-style: normal
      font-weight: normal
      font-size: 13px
      line-height: 18px
      color: rgba(38,50,56, 0.9)

    &:hover
      &:before
        border: 1px solid #486e8e !important
        transition: none

    &:after
      border-width: 1px !important

  .q-field__control-container
    padding-top: 1px
    .q-field__native
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis
      min-height: 32px

  .q-field__marginal
    height: 32px

  .fontChips
    div.ellipsis
      font-style: normal
      font-weight: normal
      font-size: 12px
      margin-right: 5px

  .q-field__native.row.items-center
    padding: 3px 0 4px 0 !important

  .q-chip
    margin-top: 2px !important
    margin-bottom: 2px !important
    margin-left: 0 !important

  .font-item
    font-style: normal
    font-weight: normal
    font-size: 13px
    line-height: 18px
    color: #01253C

.borderUnSelected div.q-checkbox__bg
  border: 1px solid #9E9E9E !important

</style>
